export const calendarDayCellSx = {
  minHeight: { xs: 92, md: 115 },
  p: 0.75
};
